import tw from 'tailwind-styled-components'

export const TwTableScrollContainer = tw.div`
  max-w-full
  overflow-x-auto
  overflow-y-auto
`

export const TwTable = tw.div`
  flex
  flex-col
  min-w-full
  text-primary
`

export const TwTableHeader = tw.div`
  w-fit
  min-w-full
  grid
  border-solid
  border-t-1
  border-l-0
  border-r-0
  border-b-1
  border-line-base
  text-placeholder
  bg-background-primary
  sticky
  top-0
  z-[2]
`

export const TwTableHeaderCol = tw.div<{
  $noBorderSides?: boolean
  $borderTop?: boolean
  $big?: boolean
  $sticky?: boolean
}>`
  p-8
  overflow-hidden
  truncate
  border-solid
  ${props => (props.$borderTop ? 'border-t-1' : 'border-t-0')}
  border-l-0
  ${props => (props.$noBorderSides ? 'border-r-0' : 'border-r-1')}
  border-b-0
  border-line-base
  last:border-r-0
  flex
  items-center
  select-none
  ${props => (props.$big ? 'h-[50px]' : 'h-[40px]')}
  ${props => (props.$sticky ? 'sticky left-0 z-[3]' : '')}
  bg-primary
`

export const TwTableBody = tw.div`
  flex
  flex-col
  w-fit
`

export const TwTableRow = tw.div`
  grid
  border-solid
  border-t-0
  border-l-0
  border-r-0
  border-b-1
  border-line-base
  hover:bg-background-hover
`

export const TwCell = tw.div<{$noBorder?: boolean; $sticky?: boolean}>`
  p-8
  truncate
  border-solid
  border-t-0
  border-l-0
  ${props => (props.$noBorder ? 'border-r-0' : 'border-r-1')}
  border-b-0
  border-line-base
  last:border-r-0
  ${props => (props.$sticky ? 'sticky left-0 z-1' : '')}
  bg-primary
`

export const TwEmptyContent = tw.div`
  p-[32px]
  flex
  justify-center
  items-center
`
